module.exports = __webpack_public_path__ + "img/news-banner.f66ae26d.png";